import { GlobalActions } from './global-actions';

export const TaasShopGlobalActions = [
  GlobalActions.EINZELWERTE_CHANGED,
  GlobalActions.IN_DASHBOARD_UEBERNEHMEN,
  GlobalActions.PRODUKT_DELETED,
  GlobalActions.VEREINBARUNGEN_CHANGED,
  GlobalActions.VERSICHERUNGSBEGINN_CHANGED,
  GlobalActions.VERTRAGSLAUFZEIT_CHANGED,
  GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED,
  GlobalActions.VORVERSICHERUNG_ABLAUFDATUM_CHANGED,
  GlobalActions.ZAHLUNGSOPTIONEN_CHANGED,
  GlobalActions.UNFALL_ZAEHLSTUECKE_CHANGED,
  GlobalActions.TARIFIERUNG_TRIGGERED,
  GlobalActions.TARIFIERUNG_TRIGGERED_BEIBEHALTUNG,
  GlobalActions.ASSEKURANZTARIF_CHANGED,
  GlobalActions.ASSEKURANZ_BEZIEHUNG_CHANGED,
  GlobalActions.UPDATE_LOADED_STATES,
];
